<template>
	<div id="layout-pdf">
		<slot />
	</div>
</template>
